import Splide from '@splidejs/splide';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

document.addEventListener('DOMContentLoaded', () => {
	const splide = new Splide('.splide', {
		type: 'loop',
		perPage: 1,
		rewind: true, // 最後のスライドから最初に戻る
		autoplay: true, // 自動再生を有効化
		interval: 4500, // 切り替え間隔（3秒）
		arrows: false, // 標準の矢印ボタンを無効化
		pagination: false, // ページネーションを無効化
		speed: 800, // トランジション速度（ミリ秒）
	});
	splide.mount();

	// GSAP に ScrollTrigger を登録
	gsap.registerPlugin(ScrollTrigger);
	document.querySelectorAll('.fade-in').forEach((el) => {
		const delay = el.dataset.delay ? parseFloat(el.dataset.delay) : 0; // HTML の data-delay を取得
		/**
         * 状態	アクション----toggleActions
            画面内に入る (onEnter)	play (再生)
            画面外に出る (onLeave)	none (何もしない)
            画面に戻る (onEnterBack)	none (何もしない)
            画面外に出る (onLeaveBack)	none (何もしない)
         */

		gsap.fromTo(
			el,
			{ opacity: 0, y: 50 },
			{
				opacity: 1,
				y: 0,
				duration: 1,
				delay: delay, // data-delay を適用
				scrollTrigger: {
					trigger: el,
					start: 'top 80%', // 画面の80%の位置に来たら開始
					toggleActions: 'play none none none', // 出たらアニメーションリセット
				},
			}
		);
	});

	// スクロールリンクのクリックイベントを登録
	document.querySelectorAll('.scroll-link').forEach((link) => {
		link.addEventListener('click', (event) => {
			event.preventDefault(); // デフォルトのアンカーリンクの動作を無効化

			const targetId = link.getAttribute('href'); // クリックされたリンクの href を取得
			const targetElement = document.querySelector(targetId); // 対象の要素を取得

			if (targetElement) {
				gsap.to(window, {
					duration: 0.8, // 1秒かけてスクロール
					scrollTo: targetElement, // スクロール先
					ease: 'sine.out', // イージングを適用
				});
			}
		});
	});

	// CVbuttonの表示
	// 対象となる要素を取得
	const aboutSection = document.getElementById('about');
	const cvScrElement = document.querySelector('.cv-scr');

	// スクロールイベントのリスナーを追加
	window.addEventListener('scroll', function () {
		// 現在のスクロール位置を取得
		const scrollPosition = window.scrollY || window.pageYOffset;

		// aboutセクションの位置情報を取得
		const aboutRect = aboutSection.getBoundingClientRect();

		// aboutセクションが画面の上部に来たとき（または少し手前で）クラスを付与
		// ここでは、aboutセクションの上端が画面の上から100px以内に入ったときに発火するよう設定
		if (aboutRect.top <= 100) {
			cvScrElement.classList.add('in-display');
		} else {
			// スクロールが戻ったときにクラスを削除（必要に応じて）
			cvScrElement.classList.remove('in-display');
		}
	});
});
